module.exports = __webpack_public_path__ + "img/spain-neoplasm-male.d3dd77eb.png";